export const MIN_P2P_AMOUNT = 5;
export const MAX_P2P_AMOUNT = 500;
